import {
  Alert,
  GridItem,
  PageGrid,
  Stack,
  RichText,
  ScrollLinkWrapper,
  CTABlock,
} from '@ads-core/components';
import { ButtonProps } from '@alliander-fe/sitecore-types';
import { CongestionFeedback } from '../CongestionFeedback';
import { ConclusionBlock } from './_ConclusionBlock';

type ConclusionProps = {
  additionalInfoBlockTitle?: string;
  additionalInfoBlockText?: string;
  additionalInfoBlockSecondaryButton?: ButtonProps;
  feedbackSecondaryButton?: ButtonProps;
  disclaimer?: string;
  conclusionUpperText?: string;
  conclusionLowerText?: string;
  conclusionFirstPrimaryButton?: ButtonProps;
  conclusionSecondPrimaryButton?: ButtonProps;
  conclusionSecondSecondaryButton?: ButtonProps;
};

export const Conclusion = ({
  additionalInfoBlockTitle,
  additionalInfoBlockText,
  additionalInfoBlockSecondaryButton,
  feedbackSecondaryButton,
  disclaimer,
  conclusionUpperText,
  conclusionLowerText,
  conclusionFirstPrimaryButton,
  conclusionSecondPrimaryButton,
  conclusionSecondSecondaryButton,
}: ConclusionProps) => {
  return (
    <Stack gap={{ initial: 12, md: 30 }}>
      {additionalInfoBlockTitle || additionalInfoBlockText || disclaimer ? (
        <PageGrid>
          <GridItem columnStart={{ initial: '1', lg: '3' }} columnEnd={{ initial: '-1', lg: '-3' }}>
            <Stack gap={10}>
              {disclaimer ? (
                <Alert variant="info">
                  <RichText>{disclaimer}</RichText>
                </Alert>
              ) : null}

              <ScrollLinkWrapper anchorId="additional">
                <CongestionFeedback
                  title={additionalInfoBlockTitle}
                  description={additionalInfoBlockText}
                  buttonPrimary={additionalInfoBlockSecondaryButton}
                  buttonSecondary={feedbackSecondaryButton}
                />
              </ScrollLinkWrapper>
            </Stack>
          </GridItem>
        </PageGrid>
      ) : null}
      {conclusionUpperText || conclusionLowerText ? (
        <PageGrid>
          <GridItem columnStart={{ initial: '1', lg: '2' }} columnEnd={{ initial: '-1', lg: '-2' }}>
            <ScrollLinkWrapper anchorId="conclusion">
              <CTABlock>
                <CTABlock.Column bg="containerPrimary" variant="main">
                  <Stack gap={6}>
                    <ConclusionBlock
                      text={conclusionUpperText}
                      primaryButton={conclusionFirstPrimaryButton}
                      secondaryButton={conclusionSecondPrimaryButton}
                    />

                    <ConclusionBlock
                      text={conclusionLowerText}
                      primaryButton={conclusionSecondPrimaryButton}
                      secondaryButton={conclusionSecondSecondaryButton}
                    />
                  </Stack>
                </CTABlock.Column>
              </CTABlock>
            </ScrollLinkWrapper>
          </GridItem>
        </PageGrid>
      ) : null}
    </Stack>
  );
};
